/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - 새로운 사람들과 만남, 채팅, 소통 즐기기",
      "올바르지 않은 전화번호",
      "Get the app",
      "Apple로 계속하기",
      "Facebook으로 계속하기",
      "Google로 계속하기",
      "로그인",
      "가입하기",
      "계속하려면 표시된 텍스트를 아래 상자에 입력하세요.",
      "계속하기",
      "텍스트를 입력하세요",
      "보안 확인",
      "다시 로드하기",
      "쉽게 기억할 수 있는 새로운 비밀번호를 설정하세요.",
      "업데이트하기",
      "비밀번호 확인",
      "비밀번호는 최소 {{num}}[[characters:num]]여야 합니다",
      "비밀번호",
      "새로운 비밀번호 설정",
      "Badoo - The Blog",
      "인재 채용",
      "채팅",
      "시",
      "쿠키 관리",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "Apple 및 Apple 로고는 Apple의 등록 상표입니다.{{__EOL__}}Google Play(은)는 Google LLC의 상표입니다.",
      "다운로드하세요",
      "Facebook",
      "팔로우하세요",
      "도움말 센터",
      "Instagram",
      "언어",
      "LinkedIn",
      "개요",
      "Badoo는 Bumble Inc의 일부입니다.",
      "개인정보 취급방침",
      "Safety Centre",
      "사이트맵",
      "현대판 노예제 방지 성명",
      "이용약관",
      "Twitter",
      "이메일 또는 핸드폰 번호를 입력하세요. 새로운 비밀번호를 설정하실 수 있는 방법을 전송해드립니다.",
      "새로운 비밀번호 받기",
      "이메일 또는 핸드폰 번호를 입력하세요",
      "비밀번호 분실",
      "사용된 모델 사진은 설명을 돕기 위한 예시입니다",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "짝을 기다리지 마세요!{{__EOL__}}{{__EOL__}}바로 채팅하며 진솔하고 솔직한 대화를 나누고 서로에 관해 더 자세히 알아가세요.",
      "채팅을 시작할까요?",
      "가입함으로써 당사의 <a class=\"link\" href=\"{{terms_url}}\">이용약관</a>에 동의하시게 됩니다. <a class=\"link\" href=\"{{privacy_url}}\">개인정보 취급방침</a>페이지에서 당사가 회원님의 데이터를 사용하는 방법을 확인하세요.",
      "진솔하고 꾸밈없는 진짜 내 모습으로<br />행복한 데이트를 하도록 도와드릴게요.",
      "데이트 여정을 자신 있게 즐겨보세요.",
      "또는",
      "이미 가입하셨나요?",
      "이메일 또는 핸드폰 번호로 가입하세요",
      "원하는 데이팅 관계를 찾아보세요.{{__EOL__}}수줍어하실 필요는 없답니다.",
      "부담 없이 채팅하고 싶으신가요? 가능하죠.{{__EOL__}}진지한 인연을 찾고 계신가요? 당연히 가능하고 말고요.{{__EOL__}}{{__EOL__}}앞으로 마음을 바꾸셔도 물론 괜찮답니다.",
      "데이트",
      "연애",
      "채팅",
      "원하는 바가 같은 사람들을 만나세요.",
      "{{name}} 님, {{age}}세",
      "저희는 회원님의 안전을 가장 중요하게 생각합니다.",
      "Safety Centre에는 자신 있는 데이트를 위해 필요한 모든 정보와 지원이 알차게 준비되어 있습니다.",
      "Safety Centre 방문하기",
      "항상, 언제나<br/>안전을 최우선으로.",
      "첫 순간부터 잘 맞을 거라는 느낌이...",
      "처음에는 진지한 연애 상대를 찾고 있진 않았는데요...",
      "Badoo 앱 회원과 공유하고 싶은 조언 한 가지는 자신의 모습을 있는 그대로 보여주는 것이...",
      "Badoo 성공 스토리",
      "더 다양한 스토리를 확인하세요",
      "{{num}}__CUT__평점",
      "Apple App Store",
      "저희를 믿으셔도 좋아요! 2006년부터 무려 수백만 명이 연결되도록 도와드리고 있어요.",
      "{{num}}M 이상__CUT__다운로드",
      "{{num}}M 이상",
      "Google Play Store",
      "전문가인 저희에게 맡겨주세요",
      "이메일 또는 핸드폰 번호로 로그인하세요",
      "비밀번호를 입력하세요",
      "비밀번호를 잊으셨나요?",
      "가입하기",
      "계정이 없으신가요?",
      "로그인",
      "회원가입"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "자"
            ],
            "singular": [
                  "자"
            ]
      },
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
